import React, { Component, useState, useEffect} from 'react';
import axios from '../../axios-instance';
import classes from './Wallet.module.scss';
import Button from '../UI/Button/Button';
import ResponsiveDialog from '../UI/ResponsiveDialog/ResponsiveDialog';
import { useSelector, useDispatch } from 'react-redux';
import { withCookies, useCookies } from 'react-cookie';
import {loadItems} from '../../store/deliveredContentSlice';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import IcLock from '../../images/icons/ic-content-preview-lock@2x.png';
import IcArrow from '../../images/icons/ic-content-preview-right-arrow@2x.png';
import IcFilter from '../../images/icons/ic-filter.png';
import {postEvent} from '../../utils/helpers';
import QrCode from '../UI/QrCode/QrCode';
import PerkpassModalHeader from '../../images/perkpass-modal-header.png';
import Logo from '../UI/Logo/Logo';

const Wallet = (props) => {
    const content = useSelector((state) => state.deliveredContent);
    const deviceSelector = useSelector((state) => state.device);

    const [modal, setModal] = useState({
        show : false,
        message : null
    });

    const [
        cookies,
        setCookie,
        // removeCookie
    ] = useCookies([
        'A8AUTH', 'A8REFER', 'A8FPVID', 'A8SELCAT', 'A8CUSTSHARELOAD', 'A8SSOISS', 'A8SSOCODE', 'A8SSOACCESSTOKEN', 'A8SSOREFRESHTOKEN', 'A8USERQRCODE', 'A8FIRSTNAME', 'A8USERTIER', 'A8CUSTOMERID']); 

    const authenticated = process.env.REACT_APP_CONTENT_LIST_AUTH_REQUIRED && Boolean(process.env.REACT_APP_CONTENT_LIST_AUTH_REQUIRED) ? Boolean(cookies.A8AUTH) : true;

    const deviceLocaleIsFrench = deviceSelector.deviceDetails.locale.search('fr') > -1;

    const registrationModuleInvitationMessage = deviceLocaleIsFrench ? process.env.REACT_APP_REGISTRATION_MODULE_INVITATION_MESSAGE_FR : process.env.REACT_APP_REGISTRATION_MODULE_INVITATION_MESSAGE_EN; 
    const registrationModuleConfirmationMessage = deviceLocaleIsFrench ? process.env.REACT_APP_REGISTRATION_MODULE_CONFIRMATION_MESSAGE_FR : process.env.REACT_APP_REGISTRATION_MODULE_CONFIRMATION_MESSAGE_EN;
    const registrationModuleButtonLabel = deviceLocaleIsFrench ? process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_LABEL_FR : process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_LABEL_EN; 
    const registrationModuleAlreadyAMemberLabel = deviceLocaleIsFrench ? process.env.REACT_APP_REGISTRATION_MODULE_ALREADY_A_MEMBER_LABEL_FR : process.env.REACT_APP_REGISTRATION_MODULE_ALREADY_A_MEMBER_LABEL_EN; 
    const registrationModuleLoginLabel = deviceLocaleIsFrench ? process.env.REACT_APP_REGISTRATION_MODULE_LOGIN_LABEL_FR : process.env.REACT_APP_REGISTRATION_MODULE_LOGIN_LABEL_EN; 
    const contentFilterSelectNoValueLabel = deviceLocaleIsFrench ? process.env.REACT_APP_CONTENT_LIST_FILTER_SELECT_NO_VALUE_LABEL_FR : process.env.REACT_APP_CONTENT_LIST_FILTER_SELECT_NO_VALUE_LABEL_EN;

    const [contentCategories, setContentCategories] = useState(null);    
    const [selectedCategory, setSelectedCategory] = useState((cookies.A8SELCAT) ? atob(cookies.A8SELCAT) : null);
    const [userQrCodeValue, setUserQrCodeValue] = useState(cookies.A8USERQRCODE)
    const [userFirstName, setUserFirstName] = useState(cookies.A8USERFIRSTNAME)
    const [userTier, setUserTier] = useState(cookies.A8USERTIER)
    const [customerId, setCustomerId] = useState(cookies.A8CUSTOMERID)
    const [showQrCode, setShowQrCode] = useState(false)
    
    const [showBackdrop, setShowBackdrop] = useState(false)    
    const [showRegistrationModal, setShowRegistrationModal] = useState(false)    
    const [showUserQrCodeModal, setShowUserQrCodeModal] = useState(false)    

    const dispatch = useDispatch();

    const extractContentCategories = (contentItems) => {

        let categoryMap = []

        if(process.env.REACT_APP_CONTENT_LIST_FILTER_OPTIONS_DYNAMIC === 'true') {
            contentItems.forEach(item => {
                item.categories.forEach(category => {
                    if(categoryMap.indexOf(category.name) < 0) {
                        categoryMap.push(category.name)
                    }                        
                });
            });
        } else {
            let staticCategoryNames = deviceLocaleIsFrench ? process.env.REACT_APP_CONTENT_LIST_FILTER_SELECT_OPTIONS_FR : process.env.REACT_APP_CONTENT_LIST_FILTER_SELECT_OPTIONS_EN;

            if(staticCategoryNames) {
                staticCategoryNames = staticCategoryNames.replaceAll("'", "");
                categoryMap = staticCategoryNames.split(',');
            }
        }

        setContentCategories(categoryMap);
    }

    const getDeviceContent = async () => {
            if(!deviceSelector.deviceDetails.uuid) {
                console.log('no device uuid');
                return;
            }

            await axios.get(`/device/${deviceSelector.deviceDetails.uuid}/content?status=[2,3,4,5]&sort_by=updated_at&sort_order=desc&limit=10`, {
                    headers: {
                        'x-device-uuid': `${deviceSelector.deviceDetails.uuid}`
                    }
        }).then((res) => {
            if(res.data.length === 0 && !cookies.A8CUSTSHARELOAD && process.env.REACT_APP_REFERRAL_CUSTOMER_HYPERLINK) {
                setCookie('A8CUSTSHARELOAD', true, {
                    maxAge: 3600,
                    path: '/',
                    sameSite: true,
                });

                window.location.href = process.env.REACT_APP_REFERRAL_CUSTOMER_HYPERLINK;
            }
            if(res.data) {
                let requestedContent = res.data.slice();
                requestedContent = sortContent(requestedContent);
                dispatch(loadItems(requestedContent))
                extractContentCategories(requestedContent);
            }
        }).catch((err) => {
                console.error('Error: ', err)
            }
        );

    }
    
    const clearWallet = async() => {
        await axios.delete(`/device/${deviceSelector.deviceDetails.uuid}/content`, {
        headers: {
                    'x-device-uuid': `${deviceSelector.deviceDetails.uuid}`
                }     
        }).then((res) => {
            if (res) {
                if (res.status === 200) {
                    setModal({
                        show: true,
                        message: res.data.message
                    });
                }
            }
        }).catch((err) => {
            setModal({
                show : true,
                message: 'Error clearing wallet'
            })
        })

    }

    const closeModal = () => {
        setModal({
            show : false,
            message: null
        })
    }
    
    const sortContent = (unsortedContent) => {
        if(!process.env.REACT_APP_CONTENT_LIST_SORT_BY_IDS_EN && !process.env.REACT_APP_CONTENT_LIST_SORT_BY_IDS_FR) {            
            return unsortedContent;
        } 

        let desiredOrder = deviceLocaleIsFrench ? process.env.REACT_APP_CONTENT_LIST_SORT_BY_IDS_FR : process.env.REACT_APP_CONTENT_LIST_SORT_BY_IDS_EN; 
        desiredOrder = desiredOrder.split(",");

        let sortedContent = [];

        desiredOrder.forEach((desiredOrderId) => {            
            unsortedContent.forEach((contentItem) => {
                if(contentItem.id === parseInt(desiredOrderId)) {
                    console.log('it is the same');
                    sortedContent.push(contentItem);
                }
            });
        });
        console.log(sortedContent);
        return sortedContent;
    }

    useEffect(() => {  
        if(!content.items || content.items.length === 0) {    
            console.log('getting device content');
            getDeviceContent();        
        } else {            
            extractContentCategories(content.items);
        }
        
        if(!authenticated) {
            setTimeout(() => {setShowBackdrop(true); setShowRegistrationModal(true)}, 4000)
        }
        

    }, [content, deviceSelector.deviceDetails.uuid]) 


    const getUserProfile = (access_token) => {
        console.log('About to fetch user profile')
        if(!cookies.A8SSOCODE) {
            console.log('Abort fetching user profile')
            return;
        }

        // let payloadEncoded = '';
        // payloadEncoded += 'client_id=' + process.env.REACT_APP_SSO_CLIENT_ID;
        // payloadEncoded += '&client_secret=' + process.env.REACT_APP_SSO_CLIENT_SECRET;
        // payloadEncoded += '&grant_type=authorization_code';
        // payloadEncoded += '&code=' + cookies.A8SSOCODE;
        // payloadEncoded += '&redirect_uri=https://perkpass.actv8me.com';


        const options = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + access_token,
                'Content-Type': 'application/json;charset=UTF-8'
            },
        };

        fetch('https://sso.dufry.com/c2id/userinfo', options)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setCookie("A8USERQRCODE", data.qr_code, process.env.REACT_APP_COOKIE_A8AUTH_EXPIRATION)
                setCookie("A8USERFIRSTNAME", data.given_name, process.env.REACT_APP_COOKIE_A8AUTH_EXPIRATION)
                setCookie("A8USERTIER", data.customer_tier, process.env.REACT_APP_COOKIE_A8AUTH_EXPIRATION)
                setCookie("A8CUSTOMERID", data.customer_id, process.env.REACT_APP_COOKIE_A8AUTH_EXPIRATION)
                
                setUserQrCodeValue(data.qr_code)
                setUserFirstName(data.given_name)
                setUserTier(data.customer_tier)
                setCustomerId(data.customer_id)
            })
            .catch(error => console.error(error));
    }

    const getAccessToken = () => {
        console.log('About to fetch access code')
        if(!cookies.A8SSOCODE) {
            console.log('Abort fetching accesscode')
            return;
        }

        let payloadEncoded = '';
        payloadEncoded += 'client_id=' + process.env.REACT_APP_SSO_CLIENT_ID;
        payloadEncoded += '&client_secret=' + process.env.REACT_APP_SSO_CLIENT_SECRET;
        payloadEncoded += '&grant_type=authorization_code';
        payloadEncoded += '&code=' + cookies.A8SSOCODE;
        payloadEncoded += '&redirect_uri=https://perkpass.actv8me.com';


        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: payloadEncoded
        };
        console.log(payloadEncoded)

        fetch('https://sso.dufry.com/c2id/token', options)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setCookie("A8SSOACCESSTOKEN", data.access_token, 600)
                setCookie("A8SSOREFRESHTOKEN", data.refresh_token, process.env.REACT_APP_COOKIE_A8AUTH_EXPIRATION)

                getUserProfile(data.access_token);

            })
            .catch(error => console.error(error));
    }


    useEffect(()=>{
        console.log('Getting QR Code value')
        console.log(cookies.A8SSOCODE)
        console.log(cookies.A8USERQRCODE)
        if(!cookies.A8USERQRCODE) {
            getAccessToken()
        }
    }, [])

    const createMarkup = (richText) => {
        return {__html: richText};
    }

    const registrationModule = <div style={{width: "100%", height: "auto", fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY, backgroundColor: "white"}}>
        <div style={{width: "100%", marginLeft: "auto", marginRight: "auto", marginBottom: "10px", paddingBottom: '10px'}}>
            {!authenticated ? 
            <div style={{color: "#000000", fontSize: "16px", fontWeight: "500", lineHeight: "26px", padding:"16px 10px 0px 10px"}}>
                {deviceLocaleIsFrench ? 'Les membres économisent 5 % dans les magasins Duty Free et Hudson participants partout dans le monde. Adhérez maintenant' : 'Members save 5% in participating Duty Free and Hudson stores worldwide.'}
                <button
                    style={{
                        backgroundColor: "white",
                        border: "none",
                        fontFamily: process.env.REACT_APP_BODY_STYLE_FONT_FAMILY,
                        fontWeight: "500",
                        fontSize: "16px", 
                        textDecoration: "underline"
                    }}
                    onClick={() => {                    
                        
                        let ssoUrl = process.env.REACT_APP_REGISTRATION_MODULE_SSO_REGISTRATION_URL;

                        if(!ssoUrl) {
                            return;
                        } else if(cookies.A8REFER) {
                            ssoUrl += '&' + atob(cookies.A8REFER)
                        }
                        
                        // Post Event as well
                        // postEvent(deviceSelector.deviceDetails, {
                        //     category : 'end-user-action',
                        //     subcategory : 'authentication',
                        //     action : 'click-through',                    
                        //     label : 'Register Button | ' + ssoUrl,
                        //     content_id : null,
                        //     client_id : deviceSelector.deviceDetails.client_id,
                        //     campaign_id : null,
                        //     trigger_id : null                    
                        // });

                        window.location.href = ssoUrl;
                    }}
                    >{deviceLocaleIsFrench ? 'Adhérer maintenant' : 'Join now'}</button>
            </div> :
            <div style={{color: "#000000", fontSize: "16px", fontWeight: "500", lineHeight: "26px", padding:"16px 10px 16px 10px"}}>
                {!deviceLocaleIsFrench && <p>Welcome back! Enjoy these exclusive offers from the <span style={{color: "#CB1416", fontWeight: "bold"}}>Red by Dufry</span> loyalty program.</p>}
                {deviceLocaleIsFrench && <p>Content de te revoir! Profitez de ces offres exclusives du programme de fidélité <span style={{color: "#CB1416", fontWeight: "bold"}}>Red by Dufry.</span></p>}
            </div>              
            }

            {!authenticated && 
                    <p style={{}}><a style={{textDecoration: "underline", color: "rgba(203, 20, 22, 1)"}} href={process.env.REACT_APP_REGISTRATION_MODULE_SSO_LOGIN_URL}>
                        {registrationModuleAlreadyAMemberLabel}&nbsp;<span style={{}}>{registrationModuleLoginLabel}</span>
                    </a></p>
            }
        </div>
    </div>

    const contentList = <div style={{backgroundColor: "rgba(237, 237, 237, 1)"}}>
            {process.env.REACT_APP_CONTENT_LIST_FILTER_DISPLAY === 'true'  && contentCategories && 
                <div style={{ float: "left", marginBottom: "10px", borderBottom: "solid 1px #f2f2f2", width: "100%", height : "auto", paddingBottom: "10px"}}>
                    <div style={{textAlign: "left", paddingLeft: '5%', paddingTop:"10px"}}>
                    <p style={{width: "18%", marginTop:"20px", float:"left", color: "black"}}>{deviceLocaleIsFrench ? 'Filtrer par' : 'Filter by'}</p>
                    <select style={{
                        width: "75%",
                        marginTop: "10px",
                        height: "40px", 
                        borderRadius: "8px", 
                        paddingLeft: "20px",
                        borderColor : "#8D8D8D",
                        boxSizing : "border-box",
                        color: "#000",
                        backgroundColor: "#fff",
                    }} onChange={(event) => {
                        setSelectedCategory(event.target.value);
                        setCookie('A8SELCAT', btoa(event.target.value), {
                            maxAge: 3600,
                            path: '/',
                            sameSite: true,
                        });
                    }}
                    value={selectedCategory}
                    >
                    <option style={{color: "#000"}} key={'no-selection'} value={null}>{contentFilterSelectNoValueLabel}</option>
                        {contentCategories.map((item) => {
                            return <option style={{color: "#000"}} key={item} value={item}>{item}</option>
                        })}                        
                    </select> 
                    </div>
                </div>
            }        
            <div style={{ marginTop: "10px"}}>
                {content?.items?.map((item) => {
                    let match = true;
                    
                    if(selectedCategory && selectedCategory !== contentFilterSelectNoValueLabel) {
                        let categoryNames = [];
                        item.categories.forEach((category) => {
                            categoryNames.push(category.name);
                        })                        

                        match = categoryNames.indexOf(selectedCategory) > -1;

                    } 

                    if(!match) {
                        return null;
                    }

                    return <div 
                                style={{
                                    textAlign: "left", 
                                    padding: "20px",
                                    height: "auto", 
                                    width: "100%", 
                                    backgroundColor: "white",
                                    // borderBottom: "solid 1px #f2f2f2", 
                                    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
                                    marginBottom: "10px",
                                    float: "left"
                                }} 
                                key={item.id}
                                >
                            { authenticated ? 

                                <Link to={'content/' + String(item.id)} onClick={() => console.log('Display content "' + item.display_name + '"')} >
                                    <div style={{width: "20%", marginRight: "5%"}}>
                                        <img src={item.images?.thumbnail?.url} alt={"Content thumbnail"} style={{width: "60px", float:"left", height: "auto", borderRadius: "8px"}}/>
                                    </div>
                                    <div style={{height: "auto", width: "70%", float: "left", marginLeft: "4%", marginRight: "4%"}}>
                                    <span style={{
                                            color:"#000",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            lineHeight: "24px"
                                        }}>{item.display_name}</span><br/>
                                        <span style={{
                                            color:"#696969",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            lineHeight: "22px"
                                        }}>{item.brand}</span>
                                    </div>
                                    {/* <div style={{width: "20%", height: "auto", float: "right", paddingTop: "22px"}}>
                                        <img src={IcLock} alt="Icon - Lock"  style={{width: "16px", heigth: "16px", marginRight: "7px", opacity: "0"}}/>
                                        <img src={IcArrow} alt="Icon - Arrow" style={{width: "8px", heigth: "8px"}}/>
                                    </div> */}
                                </Link> : 
                                <div onClick={() => window.open(process.env.REACT_APP_REGISTRATION_MODULE_SSO_URL, '_self')}>
                                    <div style={{width: "20%", marginRight: "5%"}}>
                                        <img src={item.images?.thumbnail?.url} alt={"Content thumbnail"} style={{width: "60px", float:"left", height: "auto", borderRadius: "8px"}}/>
                                    </div>
                                    <div style={{height: "auto", width: "70%", float: "left", marginLeft: "4%", marginRight: "4%"}}>
                                    <span style={{
                                            color:"#000",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            lineHeight: "24px"
                                        }}>{item.display_name}</span><br/>
                                        <span style={{
                                            color:"#696969",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            lineHeight: "22px"
                                        }}>{item.brand}</span>
                                    </div>
                                    {/* <div style={{width: "20%", height: "auto", float: "right", paddingTop: "22px"}}>
                                        <img src={IcLock} alt="Icon - Lock" style={{width: "16px", heigth: "16px", marginRight: "7px"}}/>
                                        <img src={IcArrow} alt="Icon - Arrow" style={{width: "8px", heigth: "8px"}}/>
                                    </div> */}
                                </div>
                            }
                    </div>
                })}
            </div>
    </div>

    const userProfile = <div style={{fontFamily : 'Inter'}}>                
        {!deviceLocaleIsFrench && <p style={{padding: "0 5% 0 5%", color:'black', fontWeight: "500", lineHeight: "24px"}}>Welcome back{userFirstName ? ', ' + userFirstName.trim() + '!' : '!'} Enjoy these exclusive offers from the <span style={{color: "#CB1416", fontWeight: "bold"}}>Red by Dufry</span> loyalty program.</p>}
        {deviceLocaleIsFrench && <p style={{padding: "0 5% 0 5%", color:'black', fontWeight: "500", lineHeight: "24px"}}>Content de te revoir{userFirstName ? ', ' + userFirstName.trim() + '!' : '!'} Profitez de ces offres exclusives du programme de fidélité <span style={{color: "#CB1416", fontWeight: "bold"}}>Red by Dufry.</span></p>}        
        {userQrCodeValue && <div style={{width: deviceLocaleIsFrench ? '325px' : "287px", marginLeft: "auto", marginRight: "auto"}}><Button btnText={deviceLocaleIsFrench ? 'Afficher le code QR de votre adhésion' : 'View your membership QR Code'}
            leftIcon={'qrcode'}
            style={{
                        marginTop: "0px",
                        marginBottom: "16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontFamily: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_FAMILY,
                        fontWeight: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_WIGHT,
                        color: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_COLOR,
                        border: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BORDER,
                        background: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BACKGROUND,
            }}
            onClick={() => {
                setShowBackdrop(true)
                setShowUserQrCodeModal(true)
            }}
            /></div>}        
    </div>
    
    const backDrop = <div style={{
        width: "100%",
        backgroundColor: "black",
        height: "100%",
        position: "fixed",
        zIndex : "100",
        opacity: 0.75
    }}></div>

    const registrationModal = <div>
        <div style={{
            backgroundColor: "white",
            position: "absolute",
            height: "auto",
            width: "88%",
            marginLeft: "auto",
            marginRight: "auto",
            opacity: 1,
            zIndex: "200",
            top: "50%",
            left: "50%",
            padding: "0px, 20px, 0px, 20px",
            borderRadius: "17px",
            transform: 'translate(-50%, -50%)'
            
        }}>
            <img src={PerkpassModalHeader} style={{
                width: "294px",
                marginLeft: "auto",
                marginRight: "auto"
            }}/>
            <div style={{
                // width:"100%",
                paddingLeft: "20px",
                paddingRight: "20px",
                margin: "auto 10px auto 10px",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                letterSpacing: "0px",
                textAlign: "center",
                color: "rgba(0, 0, 0, 1)"
            }}>
                {deviceLocaleIsFrench ?
                <div>
                    <p>Inscrivez-vous gratuitement pour commencer à économiser dans les magasins et les restaurants de YVR.</p>
                    <p>De plus, les membres économisent 5% dans les magasins hors taxes et Hudson participants partout dans le monde.</p>
                </div> : 
                <div>
                    <p>Join for free to start saving on <b>Shopping & Dining</b> in YVR.</p>
                    <p>Plus, members save 5% in participating Duty Free and Hudson stores worldwide.</p>
                </div>
                }

                <Button btnText={registrationModuleButtonLabel} 
                    style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        fontSize: "16px",
                        fontFamily: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_FAMILY,
                        fontWeight: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_WIGHT,
                        color: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_COLOR,
                        border: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BORDER,
                        background: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BACKGROUND,
                    }}
                    onClick={() => {                    
                        
                        let ssoUrl = process.env.REACT_APP_REGISTRATION_MODULE_SSO_REGISTRATION_URL;

                        if(!ssoUrl) {
                            return;
                        } else if(cookies.A8REFER) {
                            ssoUrl += '&' + atob(cookies.A8REFER)
                        }
                        
                        // Post Event as well
                        // postEvent(deviceSelector.deviceDetails, {
                        //     category : 'end-user-action',
                        //     subcategory : 'authentication',
                        //     action : 'click-through',                    
                        //     label : 'Register Button | ' + ssoUrl,
                        //     content_id : null,
                        //     client_id : deviceSelector.deviceDetails.client_id,
                        //     campaign_id : null,
                        //     trigger_id : null                    
                        // });

                        window.location.href = ssoUrl;
                    }}
                />
                <p style={{paddingBottom: "10px", lineHeight: "24px"}}><a style={{textDecoration: "underline", color: "rgba(203, 20, 22, 1)"}} href={process.env.REACT_APP_REGISTRATION_MODULE_SSO_LOGIN_URL}>
                    {registrationModuleAlreadyAMemberLabel}&nbsp;<span style={{}}>{registrationModuleLoginLabel}</span>
                </a></p>                
            </div>
        </div>

    </div>

    const userQrCodeModal = 
    <div>
        <div style={{
            backgroundColor: "white",
            position: "absolute",
            height: "auto",
            width: "88%",
            marginLeft: "auto",
            marginRight: "auto",
            opacity: 1,
            zIndex: "200",
            top: "229px",
            left: "25px",
            padding: "0px, 20px, 0px, 20px",
            borderRadius: "17px"
            
        }}>
            {/* <img src={PerkpassModalHeader} style={{
                width: "294px",
                marginLeft: "auto",
                marginRight: "auto"
            }}/> */}
            <div style={{
                // width:"100%",
                padding: "20px",
                margin: "auto 10px auto 10px",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                letterSpacing: "0px",
                textAlign: "center",
                color: "rgba(0, 0, 0, 1)"
            }}>
                <QrCode value={userQrCodeValue}/>
                {/* <p>{userFirstName}</p> */}
                {customerId && <p>{deviceLocaleIsFrench ? 'Votre numéro de membre est le' : 'Your member number is'} <span style={{textDecoration: 'underline'}}>{customerId}</span></p>}
                <p>{deviceLocaleIsFrench ? 'Présentez votre code QR d’adhésion Red by Dufry au moment de l’achat pour l’utiliser.' : 'Present your Red by Dufry Membership QR Code at the time of purchase to redeem.'}</p>
                <Button btnText={deviceLocaleIsFrench ? 'Fermer' : 'Close'} 
                    style={{
                        marginTop: "10px",
                        marginBottom: "20px",
                        borderRadius: "8px",
                        fontSize: "16px",
                        fontFamily: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_FAMILY,
                        fontWeight: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_WIGHT,
                        color: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_COLOR,
                        border: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BORDER,
                        background: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BACKGROUND,
                    }}
                    onClick={() => {
                        setShowUserQrCodeModal(false)
                        setShowBackdrop(false)
                    }}
                />

            </div>
        </div>

    </div>

    return (
            <div className={classes.Container} style={{backgroundColor: "rgb(237, 237, 237)"}}>
                <Logo src={deviceLocaleIsFrench ? process.env.REACT_APP_LOGO_URL_FR : process.env.REACT_APP_LOGO_URL_EN}/>
                {showBackdrop && backDrop}
                {showRegistrationModal && registrationModal}
                {showUserQrCodeModal && userQrCodeModal}
                <ResponsiveDialog
                    walletModal={true}
                    open={modal.show}
                    onClose={closeModal}>
                       {modal.message}
                </ResponsiveDialog>
                <div className={classes.WalletContainer}>
                    {/* <div>
                        <Button btnText={'Show QR Code'} onClick={() => {getUserQrCodeValue(); console.log('User QR code value: ' + userQrCodeValue)}}/>
                    </div> */}
                    {!authenticated && registrationModule}
                    {authenticated && userQrCodeValue && userProfile}
                    {authenticated && !userQrCodeValue &&
                        <Button btnText={'Tap here to access your Red By Dufry Member QR Code'}                         
                        style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                            height: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_HEIGHT?? "44px",
                            width: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_WIDTH ?? "200px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontFamily: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_FAMILY,
                            fontWeight: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_WIGHT,
                            color: 'rgb(105 174 189)',
                            // border: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BORDER,
                            background: 'none',
                        }}
                        onClick={() => {                    
                            
                            let ssoUrl = process.env.REACT_APP_REGISTRATION_MODULE_SSO_LOGIN_URL;

                            if(!ssoUrl) {
                                return;
                            } else if(cookies.A8REFER) {
                                ssoUrl += '&' + atob(cookies.A8REFER)
                            }
                            
                            // Post Event as well
                            // postEvent(deviceSelector.deviceDetails, {
                            //     category : 'end-user-action',
                            //     subcategory : 'authentication',
                            //     action : 'click-through',                    
                            //     label : 'Register Button | ' + ssoUrl,
                            //     content_id : null,
                            //     client_id : deviceSelector.deviceDetails.client_id,
                            //     campaign_id : null,
                            //     trigger_id : null                    
                            // });

                            window.location.href = ssoUrl;
                        }}
                        />
                    }

                    {contentList}
                    {
                        process.env.REACT_CONTENT_LIST_CLEAR_BUTTON_DISPLAY && process.env.REACT_CONTENT_LIST_CLEAR_BUTTON_DISPLAY === 'true' && 
                            <div className={classes.WalletCopyContainer}>
                                {/* <div className={classes.WalletTitle}>
                                    Oh, hello there!
                                </div>
                                <div className={classes.WalletCopy}>
                                    Looking to clear out your ACTV8me Wallet? Tap the button below and we’ll take care of the rest.
                                </div> */}
                                <div className={classes.ButtonContainer}>
                                    <Button onClick={clearWallet} btnText={'Clear Wallet'}></Button>
                                </div>
                            </div>
                    }
                </div>
            </div>
    )
}

export default Wallet;
